module.exports = __webpack_public_path__ + "img/i_h2_function6.d0100b97.svg";